import { useContext } from 'react';
import { Loading } from 'components/UI/Loading/Loading';
import { FeaturedEvents } from 'components/FeaturedEvents/FeaturedEvents';
import { WhatsOnGenreNoResults } from './WhatsOnGenreNoResults';
import { WhatsOnGenreEventsResults } from './WhatsOnGenreEventsResults';
import { EventFiltersContext } from '../../Shared/EventFiltersProvider';
import './WhatsOnGenreEvents.scss';

export const WhatsOnGenreEvents = () => {
  const { isLoading, eventsData } = useContext(EventFiltersContext);

  const classes = [
    ' container text-center whats-on-genre-events',
    isLoading ? 'is-loading' : '',
  ].join(' ');

  let resultsContent;

  if (isLoading) {
    resultsContent = (
      <section>
        <Loading />
      </section>
    );
  } else if (eventsData?.alternativeResults && eventsData?.events.length) {
    /*
     * The API sometimes returns generic events even though there are 'No matching results found'.
     * These events are just the 'alternative results' which do not match the filters but are shown under
     * the 'no results' text.
     */
    resultsContent = (
      <>
        <WhatsOnGenreNoResults />
        <WhatsOnGenreEventsResults />
      </>
    );
  } else if (!eventsData?.events.length) {
    resultsContent = (
      <>
        <WhatsOnGenreNoResults />
        <FeaturedEvents sectionTitle="We think you'll love" />
      </>
    );
  } else {
    resultsContent = <WhatsOnGenreEventsResults />;
  }

  return <div className={classes}>{resultsContent}</div>;
};
